module.exports = __webpack_public_path__ + "static/media/sct.25250078.webp";